import { $$ } from './utils'

const initializeLazyImageIntersectionObserver = () => {
  const lazyImages = Array.from($$('img.lazy'))

  if (lazyImages.length === 0) {
    return
  }
  let lazyImageObserver

  const loadImageIfElementOnScreen = (entry) => {
    if (entry.isIntersecting) {
      entry.target.src = entry.target.dataset.src
      lazyImageObserver.unobserve(entry.target)
    }
  }

  const observeVisibility = (lazyImage) => {
    lazyImageObserver.observe(lazyImage)
  }

  const setSrc = (element) => {
    element.src = element.dataset.src
  }

  if (typeof window.IntersectionObserver === 'function') {
    lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach(loadImageIfElementOnScreen)
    })
    lazyImages.forEach(observeVisibility)
  } else {
    lazyImages.forEach(setSrc)
  }
}

const initializeBgIntersectionObserver = () => {
  const lazyBackgrounds = Array.from($$('[data-background-image]'))

  if (lazyBackgrounds.length === 0) {
    return
  }

  let lazyBgObserver

  const loadBgIfElementOnScreen = (entry) => {
    if (entry.isIntersecting) {
      entry.target.style.backgroundImage = `url('${entry.target.dataset.backgroundImage}')`
      lazyBgObserver.unobserve(entry.target)
    }
  }

  const observeVisibility = (lazyBackground) => {
    lazyBgObserver.observe(lazyBackground)
  }

  const setBackground = (element) => {
    element.style.backgroundImage = `url('${element.dataset.backgroundImage}')`
  }

  if (typeof window.IntersectionObserver === 'function') {
    lazyBgObserver = new IntersectionObserver((entries) => {
      entries.forEach(loadBgIfElementOnScreen)
    })
    lazyBackgrounds.forEach(observeVisibility)
  } else {
    lazyBackgrounds.forEach(setBackground)
  }
}

const initializeIntersectionObserver = () => {
  initializeLazyImageIntersectionObserver()
  initializeBgIntersectionObserver()
}

if (typeof document.readyState === 'string' && document.readyState === 'complete') {
  initializeIntersectionObserver()
} else {
  document.addEventListener('DOMContentLoaded', initializeIntersectionObserver, true)
}
